import { render, staticRenderFns } from "./ClientsSelect.vue?vue&type=template&id=ac0fd7fa&"
import script from "./ClientsSelect.vue?vue&type=script&lang=js&"
export * from "./ClientsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports